<template>
  <div id="about">
    <div class="mt-0 pt-0">
      <v-container class="content-wrapper">
        <v-row class="mt-5 pt-5">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="10" lg="10" md="12" sm="12">
            <v-btn
              depressed
              rounded
              small
              color="primary300"
              class="white--text font-weight-bold"
              :to="{ name: 'PublicEvents' }"
            >
              <v-icon color="black" small class="mr-2">
                mdi-arrow-left
              </v-icon>
              Back to Events
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="10" lg="10" md="12" sm="12">
            <h2 class="primary300--text">
              {{ event.title }}
            </h2>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col v-if="event.date" cols="12" xl="10" lg="10" md="12" sm="12">
            <p class="black--text font-weight-bold">
              {{ formatDateLocaleAE(event.date) }}
            </p>
          </v-col>
          <v-col v-else cols="12" xl="10" lg="10" md="12" sm="12">
            <p class="black--text font-weight-bold">
              {{
                event.dateFrom === event.dateTo
                  ? formatDateLocaleAE(event.dateFrom)
                  : formatDateLocaleAE(event.dateFrom) + ' - ' + formatDateLocaleAE(event.dateTo)
              }}
            </p>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12">
            <v-img
              v-if="event.thumbnail"
              width="100%"
              height="477px"
              :src="event.thumbnail"
              style="border-radius: 24px; overflow: hidden;"
            ></v-img>
            <v-img
              v-else
              width="100%"
              height="477px"
              :src="require('@/assets/img/landing-page/pages/events.png')"
              gradient="to top right, rgba(61, 1, 154, 0.4), rgba(61, 1, 154, 0.4)"
              style="border-radius: 24px; overflow: hidden;"
            ></v-img>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-5 pt-5">
          <v-spacer></v-spacer>
          <v-col
            cols="12"
            xl="6"
            lg="6"
            md="12"
            sm="12"
            style="word-wrap: break-word; overflow-wrap: break-word;"
          >
            <div class="black--text" v-html="event.description"></div>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12">
            <h3 class="primary200--text">
              Domain
            </h3>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12" class="mt-0 pt-0">
            <p>
              <span v-for="(domain, index) in uniqueDomains(event.scientifics)" :key="index">
                {{ domain }}
                <span v-if="index < uniqueDomains(event.scientifics).length - 1">/ </span>
              </span>
            </p>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12">
            <h3 class="primary200--text">
              Subdomain
            </h3>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12" class="mt-0 pt-0">
            <p>
              <span v-for="(domain, index) in event.scientifics" :key="index">
                {{ domain.subDomain }}
                <span v-if="index < event.scientifics.length - 1">/ </span>
              </span>
            </p>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row v-if="event.tags.length > 0" class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12">
            <h3 class="primary200--text">
              Tags
            </h3>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row v-if="event.tags.length > 0" class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12">
            <v-chip
              :color="color(index)"
              v-for="(tag, index) in event.tags"
              :key="index"
              class="ma-1"
            >
              {{ tag }}
            </v-chip>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row v-if="event.files.length > 0" class="mt-5 pt-5">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12">
            <h3 class="primary200--text">
              Files
            </h3>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row v-if="event.files.length > 0" class="mt-0 pt-0">
          <v-spacer></v-spacer>
          <v-col cols="12" xl="6" lg="6" md="12" sm="12">
            <v-chip
              v-for="(file, index) in event.files"
              :key="index"
              :color="color(index)"
              class="ma-1"
              @click="handleFileClick(file)"
            >
              {{ file }}
            </v-chip>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </v-container>
    </div>

    <!-- Related Events -->
    <v-row v-if="relatedEvents.length > 0" style="background-color: rgba(237, 224, 255, 1);">
      <v-container class="d-flex flex-wrap">
        <v-col cols="12" class="pa-5 ma-5 d-flex justify-space-between align-center">
          <h2>Discover related events</h2>
          <div>
            <v-btn :disabled="currentPage === 1" @click="currentPage--" small plain>
              <v-icon color="black" small class="mr-2">
                mdi-arrow-left
              </v-icon>
            </v-btn>
            <span> {{ currentPage }} / {{ totalPages }}</span>
            <v-btn :disabled="currentPage === totalPages" @click="currentPage++" small plain>
              <v-icon color="black" small class="mr-2">
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col
          cols="12"
          xl="4"
          lg="4"
          md="6"
          sm="6"
          xs="12"
          class="pa-3"
          v-for="(related, index) in paginatedRelatedEvents"
          :key="'related-' + index"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              class="d-flex flex-column"
              elevation="3"
              style="border-radius: 24px; height: 100%;"
              :class="{ 'on-hover': hover }"
              @click="handleCardClick(related.id)"
            >
              <div style="position: relative; width: 100%; text-align: center; overflow: hidden;">
                <div style="display: flex; justify-content: center; width: 100%; overflow: hidden;">
                  <v-img v-if="related.thumbnail" height="250" :src="getThumbnailUrl(related)">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="primary300 "
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-img
                    v-else
                    height="250"
                    :src="require('@/assets/img/landing-page/pages/events.png')"
                    gradient="to top right, rgba(61, 1, 154, 0.4), rgba(61, 1, 154, 0.4)"
                  ></v-img>
                  <!-- <v-chip
                    style="position: absolute; top: 15px; left: 15px;"
                    color="secondary300"
                    dark
                  >
                    Events
                  </v-chip> -->
                </div>
              </div>

              <div class="black d-flex flex-column flex-grow-1">
                <v-card-title class="white--text">
                  <v-row>
                    <v-col>
                      <div>
                        {{ related.title }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text class="flex-grow-1">
                  <v-row>
                    <v-col class="white--text">
                      <div v-html="truncateDescription(related.description)"></div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text>
                  <div
                    v-if="related.tags.length > 0"
                    style="min-height: 40px;"
                    class="d-flex align-center flex-wrap"
                  >
                    <v-chip
                      :color="color(index)"
                      v-for="(tag, index) in related.tags"
                      :key="index"
                      class="ma-2"
                    >
                      {{ tag }}
                    </v-chip>
                  </div>
                </v-card-text>
                <v-divider class="mx-4 white"></v-divider>

                <v-card-actions>
                  <v-row align="center">
                    <v-col class="d-flex align-center">
                      <v-btn icon style="min-width: auto;">
                        <v-icon style="color: white !important;" class="mr-2">
                          mdi-arrow-top-right
                        </v-icon>
                      </v-btn>
                      <p class="mb-0 white--text">Read more</p>
                    </v-col>
                    <v-col v-if="related.date" class="d-flex justify-end">
                      <v-icon style="color: white !important;">mdi-circle-small</v-icon>
                      <p class="white--text mb-0">
                        {{ formatDateLocaleAE(related.date) }}
                      </p>
                    </v-col>
                    <v-col v-else class="d-flex justify-end">
                      <v-icon style="color: white !important;">mdi-circle-small</v-icon>
                      <p class="white--text mb-0">
                        {{ formatDateLocaleAE(related.dateFrom) }} -
                        {{ formatDateLocaleAE(related.dateTo) }}
                      </p>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-container>
    </v-row>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';

export default {
  name: 'OverviewEvents',
  mixins: [util],
  data() {
    return {
      event: {
        thumbnail: null,
        title: '',
        description: '',
        date: '',
        dateFrom: '',
        dateTo: '',
        tags: [],
        scientifics: [],
        files: [],
      },
      relatedEvents: [],
      currentPage: null,
      itemsPerPage: 3,
    };
  },
  mounted() {
    this.getEvent();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.relatedEvents.length / this.itemsPerPage);
    },
    paginatedRelatedEvents() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.relatedEvents.slice(start, end);
    },
    // formattedDateRange() {
    //   const start = this.formatDateLocaleAE(this.event.dateFrom);
    //   const end = this.formatDateLocaleAE(this.event.dateTo);
    //   return start === end ? start : `${start} - ${end}`;
    // },
  },
  methods: {
    getEvent() {
      EventBus.$emit('waiting', true);
      const id = this.$route.params.id;

      this.axios
        .get(`/api/v1/news-and-events/${id}/published`)
        .then(response => {
          console.log('Get Event', response.data);

          this.event.title = response.data.title;
          this.event.description = response.data.description;

          this.event.tags = response.data.tags;
          this.event.scientifics = response.data.scientifics;

          if (response.data.dateFrom && response.data.dateTo) {
            this.event.dateFrom = response.data.dateFrom;
            this.event.dateTo = response.data.dateTo;
            this.event.date = null;
          } else if (response.data.date) {
            this.event.date = response.data.date;
            this.event.dateFrom = null;
            this.event.dateTo = null;
          }

          if (response.data.files && response.data.files.length > 0) {
            this.event.files = response.data.files;
          }

          const id = response.data.id;

          this.getRelated(id);

          if (response.data.thumbnail) {
            const thumbnailName = response.data.thumbnail;

            return this.axios.get(`/api/v1/news-and-events/${id}/thumbnail/${thumbnailName}`, {
              responseType: 'blob',
            });
          }
        })
        .then(thumbnailResponse => {
          if (thumbnailResponse) {
            console.log('Thumbnail Data', thumbnailResponse);

            const imageUrl = URL.createObjectURL(thumbnailResponse.data);

            this.event.thumbnail = imageUrl;
          }
        })
        .catch(error => {
          console.error('Error fetching event or thumbnail data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    getRelated(id) {
      EventBus.$emit('waiting', true);

      const excludedId = this.$route.params.id;

      this.axios
        .get(`api/v1/news-and-events/related/${id}`)
        .then(response => {
          console.log('Ralated data:', response.data);

          this.relatedEvents = response.data.filter(event => event.id !== parseInt(excludedId, 10));
          this.currentPage = 1;
        })
        .catch(error => {
          console.error('Error fetching related data:', error);
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    uniqueDomains(scientifics) {
      return [...new Set(scientifics.map(sci => sci.domain))];
    },
    getThumbnailUrl(related) {
      return related && related.thumbnail
        ? `/api/v1/news-and-events/${related.id}/thumbnail/${related.thumbnail}`
        : '';
    },
    truncateDescription(description) {
      if (!description) return 'No description available.';

      const words = description.split(' ');

      if (words.length > 15) {
        return words.slice(0, 15).join(' ') + '...';
      }

      return description;
    },
    handleCardClick(relatedId) {
      this.$router.replace({ name: 'OverviewEvents', params: { id: relatedId } });
      this.$nextTick(() => {
        this.getEvent();
      });
    },
    handleFileClick(file) {
      const id = this.$route.params.id;
      const encodedFile = encodeURIComponent(file);
      const filePath = `api/v1/news-and-events/${id}/file/${encodedFile}`;

      this.axios
        .get(filePath, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = fileURL;
          a.download = file;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(fileURL);
        })
        .catch(error => {
          console.error('Error fetching file:', error);
        });
    },
  },
};
</script>

<style scoped>
.hover-button:hover {
  color: white !important;
}

.hover-button:hover .v-icon {
  color: white !important;
}
</style>
